// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__u6DWp","contrast":"Section_contrast__yzNqz","secondary":"Section_secondary__V_z1A"};